import { ENV_API_URL } from 'common/constants/env.constants.ts';

export const API_ENDPOINTS = {
  BASE_URL: ENV_API_URL,
  ROLES_ACCESS_REQUEST: '/roles/access-request',
};
